var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left-tree"},[_c('div',{staticClass:"left-tree-title"},[_c('span'),_vm._t("default")],2),_vm._v(" "),_c('el-tree',{ref:"tree",attrs:{"data":_vm.topicCategorys,"props":_vm.defaultProps,"node-key":"value","defaultCheckedKeys":_vm.defaultCheckedProvince,"accordion":""},on:{"node-click":_vm.handleNodeClick}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-607b9160","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/treeList/TreeListBook.vue
// module id = null
// module chunks = 